import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'
import AnalysesList from './AnalysesList'

const resource = {
  list: AnalysesList,
  icon: ListAltOutlinedIcon
}

export default resource
